import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { AuditData } from "../../../events/Setting/types"

export type SettingFormItemValue = {
    value: Maybe<any>
    indeterminate: boolean
}

export type SettingFormItem = Record<string, SettingFormItemValue>

export type TerminalLocationIdPair = {
    locationId: Maybe<string>
    terminalId: Maybe<string>
}

export type SettingDTO = {
    key: Maybe<string>
    value: Maybe<any>
    locationId: Maybe<string>
    terminalId: Maybe<string>
}

export enum ReadyDateOption {
    Fixed = "fixed",
    Offset = "offset",
}

export const DEFAULT_READY_DATE_CONFIGURATION = {
    option: ReadyDateOption.Fixed,
    days: 0,
    hours: 12,
    minutes: 0,
    isEnabled: false,
}

export enum ReadyDateOptionUI {
    Off = "off",
    SameDay = "same-day",
    NextDay = "next-day",
    TwoPlusDays = "two-plus-days",
    Offset = "offset",
}

export type ReadyDateConfiguration = {
    option: Maybe<ReadyDateOption>
    days: number
    hours: number
    minutes: number
    isEnabled: boolean
}

export type WeekStartDay = "Sunday" | "Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday" | "Saturday"

export type ChangedSettingLog = { key: string; prev: any | null; next: any | null }

export type SettingsUpdateType = {
    id?: string
    key: string
    location_id: Maybe<string>
    terminal_id: Maybe<string>
    value: any
}

export interface LoyaltyProgramAddedPayload {
    id: string
    rewardsIncentive: Maybe<number>
    redemptionMinimum: Maybe<number>
    startDate: string
    auditData: AuditData
}

export interface LoyaltyProgramUpdatedPayload {
    id: string
    rewardsIncentive: Maybe<number>
    redemptionMinimum: Maybe<number>
    startDate: Maybe<string>
    auditData: AuditData
}

export interface LoyaltyProgramDeletedPayload {
    id: string
    auditData: AuditData
}
